import { apiPost } from '@/services/api/client';
import { dashboardFromJson, type DashboardData } from '@/models/dashboard';

export async function fetchDashboard(args: {
  userId: string;
  mdType: string;
}): Promise<DashboardData> {
  const body = await apiPost<Record<string, unknown>>(
    'dash',
    { userId: args.userId, mdType: args.mdType },
    { timeoutMs: 20_000 },
  );
  return dashboardFromJson(body);
}
